import { render, staticRenderFns } from "./AdminStudentUpdateForm.vue?vue&type=template&id=60409cba"
import script from "./AdminStudentUpdateForm.vue?vue&type=script&lang=js"
export * from "./AdminStudentUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports